import {
  Typography,
  TextField,
  MenuItem,
  Accordion,
  AccordionDetails,
  Box,
  Checkbox,
  FormControlLabel,
  FormControl,
  FormLabel,
  FormGroup,
  AccordionSummary,
} from "@mui/material";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import Grid2 from "@mui/material/Grid2";
import {
  muscleOptions,
  difficultyOptions,
  modalityOptions,
  exerciseOptions,
} from "../Utility/Constants";
import NotesTextField from "../Worklist/NotesTextField";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { saveFormDataToLocal } from "../Utility/FormDataTempStorage";
import { useEffect, useRef } from "react";
import { useDebouncedEffect } from "../Utility/Utility";

function FrozenShoulderPrescriptionDisplay({
  formData,
  readOnly,
  setFormData,
  uniqueId,
}) {
  const timeoutRef = useRef(null);

  // Custom useDebounceEffect hook
  //   const useDebounceEffect = (callback, delay, dependencies) => {
  //     useEffect(() => {
  //       if (timeoutRef.current) {
  //         clearTimeout(timeoutRef.current);
  //       }

  //       timeoutRef.current = setTimeout(() => {
  //         callback();
  //       }, delay);

  //       return () => {
  //         if (timeoutRef.current) {
  //           clearTimeout(timeoutRef.current);
  //         }
  //       };
  //     }, dependencies);
  //   };

  // Debounced save function
  //   useDebouncedEffect(
  //     () => {
  //       if (formData && uniqueId) {
  //         saveFormDataToLocal(uniqueId, formData);
  //       }
  //     },
  //     1000,
  //     [formData, uniqueId]
  //   );

  const renderReadOnlyValue = (label, value) => {
    return (
      <Grid2 container spacing={1} alignItems="center">
        <Grid2 size={{ xs: 12, sm: 4 }}>
          <Typography fontWeight="bold">{label}</Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 8 }}>
          {value === "" || value == null ? (
            <Typography fontStyle="italic" color="text.secondary">
              Not mentioned
            </Typography>
          ) : (
            <Typography>{value}</Typography>
          )}
        </Grid2>
      </Grid2>
    );
  };

  const handleFormDataChange = (updatedValues) => {
    //const updatedDetailedFormData = {...formData, ...updatedValues};
    saveFormDataToLocal(uniqueId, updatedValues);
    // The debounced save will be handled by useDebounceEffect
  };

  const renderDropdownRow = (label, value, setValue, options) => (
    <Grid2 container spacing={1} alignItems="center">
      <Grid2 size={{ xs: 12, sm: 4 }}>
        <Typography>{label}</Typography>
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 8 }}>
        {readOnly ? (
          <Typography>{value}</Typography>
        ) : (
          <TextField
            select
            size="small"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            fullWidth
          >
            {options.map((opt) => (
              <MenuItem key={opt} value={opt}>
                {opt}
              </MenuItem>
            ))}
          </TextField>
        )}
      </Grid2>
    </Grid2>
  );

  return (
    <Grid2 container size={12} spacing={2}>
      {/* Chief Complaint & HOPI */}
      <Grid2 size={12}>
        <Accordion defaultExpanded variant="outlined">
          <AccordionSummary expandIcon={<GridExpandMoreIcon />}>
            <Typography component="span">Chief Complaint & HOPI</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "16px" }}>
            <Grid2 container size={12} spacing={3}>
              {/* Side */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Side",
                      formData?.chiefComplaint?.complaintSide,
                    )
                  : renderDropdownRow(
                      "Side",
                      formData?.chiefComplaint?.complaintSide,
                      (value) => {
                        setFormData({
                          ...formData,
                          chiefComplaint: {
                            ...formData.chiefComplaint,
                            complaintSide: value,
                          },
                        });
                        handleFormDataChange({
                          chiefComplaint: {
                            ...formData.chiefComplaint,
                            complaintSide: value,
                          },
                        });
                      },
                      ["Right", "Left"],
                    )}
              </Grid2>

              {/* Duration */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly ? (
                  renderReadOnlyValue(
                    "Duration",
                    formData?.chiefComplaint?.durationValue === ""
                      ? ""
                      : formData?.chiefComplaint?.durationValue +
                          " " +
                          formData?.chiefComplaint?.durationUnit,
                  )
                ) : (
                  <Grid2 container spacing={1} alignItems="center">
                    <Grid2 size={{ xs: 12, sm: 4 }}>
                      <Typography>Duration</Typography>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 4 }}>
                      <TextField
                        type="number"
                        size="small"
                        value={formData?.chiefComplaint?.durationValue || ""}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            chiefComplaint: {
                              ...formData.chiefComplaint,
                              durationValue: e.target.value,
                            },
                          });
                          handleFormDataChange({
                            chiefComplaint: {
                              ...formData?.chiefComplaint,
                              durationValue: e.target.value,
                            },
                          });
                        }}
                        fullWidth
                        placeholder="Enter duration"
                      />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 4 }}>
                      {readOnly ? (
                        renderReadOnlyValue(
                          "",
                          formData?.chiefComplaint?.durationUnit,
                        )
                      ) : (
                        <TextField
                          select
                          size="small"
                          value={formData?.chiefComplaint?.durationUnit}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              chiefComplaint: {
                                ...formData.chiefComplaint,
                                durationUnit: e.target.value,
                              },
                            });
                            handleFormDataChange({
                              chiefComplaint: {
                                ...formData.chiefComplaint,
                                durationUnit: e.target.value,
                              },
                            });
                          }}
                          fullWidth
                        >
                          <MenuItem value="Years">Years</MenuItem>
                          <MenuItem value="Months">Months</MenuItem>
                          <MenuItem value="Weeks">Weeks</MenuItem>
                          <MenuItem value="Days">Days</MenuItem>
                        </TextField>
                      )}
                    </Grid2>
                  </Grid2>
                )}
              </Grid2>

              {/* Nature of Pain */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Nature of Pain",
                      formData?.chiefComplaint?.natureOfPain,
                    )
                  : renderDropdownRow(
                      "Nature of Pain",
                      formData?.chiefComplaint?.natureOfPain,
                      (value) => {
                        setFormData({
                          ...formData,
                          chiefComplaint: {
                            ...formData?.chiefComplaint,
                            natureOfPain: value,
                          },
                        });
                        handleFormDataChange({
                          chiefComplaint: {
                            ...formData?.chiefComplaint,
                            natureOfPain: value,
                          },
                        });
                      },
                      ["Continuous", "On Activity"],
                    )}
              </Grid2>

              {/* Symptoms */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Symptoms",
                      formData?.chiefComplaint?.symptoms,
                    )
                  : renderDropdownRow(
                      "Symptoms",
                      formData?.chiefComplaint?.symptoms,
                      (value) => {
                        setFormData({
                          ...formData,
                          chiefComplaint: {
                            ...formData.chiefComplaint,
                            symptoms: value,
                          },
                        });
                        handleFormDataChange({
                          chiefComplaint: {
                            ...formData.chiefComplaint,
                            symptoms: value,
                          },
                        });
                      },
                      ["Improving", "Worsening", "Remain Same"],
                    )}
              </Grid2>

              {/* Onset */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue("Onset", formData.chiefComplaint.onset)
                  : renderDropdownRow(
                      "Onset",
                      formData?.chiefComplaint?.onset,
                      (value) => {
                        setFormData({
                          ...formData,
                          chiefComplaint: {
                            ...formData?.chiefComplaint,
                            onset: value,
                          },
                        });
                        handleFormDataChange({
                          chiefComplaint: {
                            ...formData?.chiefComplaint,
                            onset: value,
                          },
                        });
                      },
                      ["Gradual", "Sudden"],
                    )}
              </Grid2>
              {/* Type of Injury */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Type of Injury",
                      formData?.chiefComplaint?.typeOfInjury,
                    )
                  : renderDropdownRow(
                      "Type of Injury",
                      formData?.chiefComplaint?.typeOfInjury,
                      (value) => {
                        setFormData({
                          ...formData,
                          chiefComplaint: {
                            ...formData?.chiefComplaint,
                            typeOfInjury: value,
                          },
                        });
                        handleFormDataChange({
                          chiefComplaint: {
                            ...formData?.chiefComplaint,
                            typeOfInjury: value,
                          },
                        });
                      },
                      ["Fall", "RTA", "Throwing", "Lifting", "Other"],
                    )}
              </Grid2>

              {/* Aggravating Factor */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Aggravating Factor",
                      formData?.chiefComplaint?.aggravatingFactor,
                    )
                  : renderDropdownRow(
                      "Aggravating Factor",
                      formData?.chiefComplaint?.aggravatingFactor,
                      (value) => {
                        setFormData({
                          ...formData,
                          chiefComplaint: {
                            ...formData?.chiefComplaint,
                            aggravatingFactor: value,
                          },
                        });
                        handleFormDataChange({
                          chiefComplaint: {
                            ...formData?.chiefComplaint,
                            aggravatingFactor: value,
                          },
                        });
                      },
                      ["Any Movement of Shoulder Joint"],
                    )}
              </Grid2>

              {/* Relieving Factor */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Relieving Factor",
                      formData?.chiefComplaint?.relievingFactor,
                    )
                  : renderDropdownRow(
                      "Relieving Factor",
                      formData?.chiefComplaint?.relievingFactor,
                      (value) => {
                        setFormData({
                          ...formData,
                          chiefComplaint: {
                            ...formData?.chiefComplaint,
                            relievingFactor: value,
                          },
                        });
                        handleFormDataChange({
                          chiefComplaint: {
                            ...formData?.chiefComplaint,
                            relievingFactor: value,
                          },
                        });
                      },
                      [
                        "Rest",
                        "Medication",
                        "Icepad",
                        "Movement",
                        "Heatpad",
                        "Nothing",
                      ],
                    )}
              </Grid2>

              {/* Night Pain */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Night Pain",
                      formData?.chiefComplaint?.nightPain,
                    )
                  : renderDropdownRow(
                      "Night Pain",
                      formData?.chiefComplaint?.nightPain,
                      (value) => {
                        setFormData({
                          ...formData,
                          chiefComplaint: {
                            ...formData?.chiefComplaint,
                            nightPain: value,
                          },
                        });
                        handleFormDataChange({
                          chiefComplaint: {
                            ...formData?.chiefComplaint,
                            nightPain: value,
                          },
                        });
                      },
                      ["Increased", "Decreased"],
                    )}
              </Grid2>

              {/* Sleep Disturbance */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Sleep Disturbance",
                      formData?.chiefComplaint?.sleepDisturbance,
                    )
                  : renderDropdownRow(
                      "Sleep Disturbance",
                      formData?.chiefComplaint?.sleepDisturbance,
                      (value) => {
                        setFormData({
                          ...formData,
                          chiefComplaint: {
                            ...formData?.chiefComplaint,
                            sleepDisturbance: value,
                          },
                        });
                        handleFormDataChange({
                          chiefComplaint: {
                            ...formData?.chiefComplaint,
                            sleepDisturbance: value,
                          },
                        });
                      },
                      ["Yes", "No"],
                    )}
              </Grid2>
              <Grid2 size={12}>
                {readOnly ? (
                  renderReadOnlyValue(
                    "Chief Complaint Notes",
                    formData?.chiefComplaint?.notes,
                  )
                ) : (
                  <NotesTextField
                    value={formData?.chiefComplaint?.notes || ""}
                    onChange={(newValue) => {
                      setFormData({
                        ...formData,
                        chiefComplaint: {
                          ...formData.chiefComplaint,
                          notes: newValue,
                        },
                      });
                      handleFormDataChange({
                        chiefComplaint: {
                          ...formData.chiefComplaint,
                          notes: newValue,
                        },
                      });
                    }}
                    label="Chief Complaint Notes"
                    rows={3}
                  />
                )}
              </Grid2>
            </Grid2>
          </AccordionDetails>
        </Accordion>
      </Grid2>

      {/* Past History */}
      <Grid2 size={12}>
        <Accordion variant="outlined">
          <AccordionSummary expandIcon={<GridExpandMoreIcon />}>
            <Typography component="span">Past History</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "16px" }}>
            <Grid2 container size={12} spacing={3}>
              {/* HTN */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue("HTN", formData.pastHistory.htn)
                  : renderDropdownRow(
                      "HTN",
                      formData?.pastHistory?.htn,
                      (value) => {
                        setFormData({
                          ...formData,
                          pastHistory: {
                            ...formData?.pastHistory,
                            htn: value,
                          },
                        });
                        handleFormDataChange({
                          pastHistory: {
                            ...formData?.pastHistory,
                            htn: value,
                          },
                        });
                      },
                      ["No", "Yes-Regular Meds", "Yes-Irregular Meds"],
                    )}
              </Grid2>

              {/* DM2 */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue("DM2", formData.pastHistory.dm2)
                  : renderDropdownRow(
                      "DM2",
                      formData?.pastHistory?.dm2,
                      (value) => {
                        setFormData({
                          ...formData,
                          pastHistory: {
                            ...formData?.pastHistory,
                            dm2: value,
                          },
                        });
                        handleFormDataChange({
                          pastHistory: {
                            ...formData?.pastHistory,
                            dm2: value,
                          },
                        });
                      },
                      [
                        "No",
                        "Yes-Regular Meds",
                        "Yes-Irregular Meds",
                        "Insulin",
                      ],
                    )}
              </Grid2>

              {/* Hypothyroid */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Hypothyroidism",
                      formData.pastHistory.hypothyroid,
                    )
                  : renderDropdownRow(
                      "Hypothyroidism",
                      formData?.pastHistory?.hypothyroid,
                      (value) => {
                        setFormData({
                          ...formData,
                          pastHistory: {
                            ...formData?.pastHistory,
                            hypothyroid: value,
                          },
                        });
                        handleFormDataChange({
                          pastHistory: {
                            ...formData?.pastHistory,
                            hypothyroid: value,
                          },
                        });
                      },
                      ["No", "Yes-Regular Meds", "Yes-Irregular Meds"],
                    )}
              </Grid2>

              {/* Rx History */}
              <Grid2 size={12}>
                {/* <Typography fontWeight="bold" gutterBottom>
                          Rx History
                        </Typography> */}
                {readOnly ? (
                  renderReadOnlyValue(
                    "Rx History",
                    formData?.pastHistory?.rxHistory,
                  )
                ) : (
                  <NotesTextField
                    value={formData?.pastHistory?.rxHistory || ""}
                    onChange={(newValue) => {
                      setFormData({
                        ...formData,
                        pastHistory: {
                          ...formData?.pastHistory,
                          rxHistory: newValue,
                        },
                      });
                      handleFormDataChange({
                        pastHistory: {
                          ...formData?.pastHistory,
                          rxHistory: newValue,
                        },
                      });
                    }}
                    label="Enter prescription history"
                    rows={3}
                  />
                )}
              </Grid2>
            </Grid2>
          </AccordionDetails>
        </Accordion>
      </Grid2>

      {/* On Examination */}
      <Grid2 size={12}>
        <Accordion variant="outlined">
          <AccordionSummary expandIcon={<GridExpandMoreIcon />}>
            <Typography component="span">On Examination</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "16px" }}>
            <Grid2 container size={12} spacing={3}>
              {/* Side Examined */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Side Examined",
                      formData?.examination?.examSide,
                    )
                  : renderDropdownRow(
                      "Side Examined",
                      formData?.examination?.examSide,
                      (value) => {
                        setFormData({
                          ...formData,
                          examination: {
                            ...formData?.examination,
                            examSide: value,
                          },
                        });
                        handleFormDataChange({
                          examination: {
                            ...formData?.examination,
                            examSide: value,
                          },
                        });
                      },
                      ["Right", "Left"],
                    )}
              </Grid2>

              {/* Swelling */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Swelling",
                      formData?.examination?.swelling,
                    )
                  : renderDropdownRow(
                      "Swelling",
                      formData?.examination?.swelling,
                      (value) => {
                        setFormData({
                          ...formData,
                          examination: {
                            ...formData?.examination,
                            swelling: value,
                          },
                        });
                        handleFormDataChange({
                          examination: {
                            ...formData?.examination,
                            swelling: value,
                          },
                        });
                      },
                      ["Yes", "No"],
                    )}
              </Grid2>

              {/* Muscle Wasting */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Muscle Wasting",
                      formData?.examination?.muscleWasting,
                    )
                  : renderDropdownRow(
                      "Muscle Wasting",
                      formData?.examination?.muscleWasting,
                      (value) => {
                        setFormData({
                          ...formData,
                          examination: {
                            ...formData?.examination,
                            muscleWasting: value,
                          },
                        });
                        handleFormDataChange({
                          examination: {
                            ...formData?.examination,
                            muscleWasting: value,
                          },
                        });
                      },
                      ["Yes", "No"],
                    )}
              </Grid2>

              {/* Neurological Deficit */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly ? (
                  renderReadOnlyValue(
                    "Neurological Deficit",
                    formData?.examination?.neuroDeficit === "No" ? "No" :
                    formData?.examination?.neuroDeficit +
                      " " +
                      formData?.examination?.neuroDeficitType,
                  )
                ) : (
                  <Grid2 container spacing={1} alignItems="center">
                    <Grid2 size={{ xs: 12, sm: 4 }}>
                      <Typography>Neurological Deficit</Typography>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 4 }}>
                      <TextField
                        select
                        size="small"
                        value={formData?.examination?.neuroDeficit}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            examination: {
                              ...formData?.examination,
                              neuroDeficit: e.target.value,
                            },
                          });
                          handleFormDataChange({
                            examination: {
                              ...formData?.examination,
                              neuroDeficit: e.target.value,
                            },
                          });
                        }}
                        fullWidth
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </TextField>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 4 }}>
                      <TextField
                        select
                        size="small"
                        value={formData?.examination?.neuroDeficitType}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            examination: {
                              ...formData?.examination,
                              neuroDeficitType: e.target.value,
                            },
                          });
                          handleFormDataChange({
                            examination: {
                              ...formData?.examination,
                              neuroDeficitType: e.target.value,
                            },
                          });
                        }}
                        fullWidth
                        disabled={formData?.examination?.neuroDeficit === "No"}
                      >
                        <MenuItem value="Motor">Motor</MenuItem>
                        <MenuItem value="Sensory">Sensory</MenuItem>
                      </TextField>
                    </Grid2>
                  </Grid2>
                )}
              </Grid2>

              {/* Capsular Pattern Altered */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Capsular Pattern Altered",
                      formData?.examination?.capsularPattern,
                    )
                  : renderDropdownRow(
                      "Capsular Pattern Altered",
                      formData?.examination?.capsularPattern,
                      (value) => {
                        setFormData({
                          ...formData,
                          examination: {
                            ...formData?.examination,
                            capsularPattern: value,
                          },
                        });
                        handleFormDataChange({
                          examination: {
                            ...formData?.examination,
                            capsularPattern: value,
                          },
                        });
                      },
                      ["Yes", "No"],
                    )}
              </Grid2>

              {/* Muscle Tightness */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Muscle Tightness",
                      formData?.examination?.muscleTightness,
                    )
                  : renderDropdownRow(
                      "Muscle Tightness",
                      formData?.examination?.muscleTightness,
                      (value) => {
                        setFormData({
                          ...formData,
                          examination: {
                            ...formData?.examination,
                            muscleTightness: value,
                          },
                        });
                        handleFormDataChange({
                          examination: {
                            ...formData?.examination,
                            muscleTightness: value,
                          },
                        });
                      },
                      ["Yes", "No"],
                    )}
              </Grid2>

              {/* Muscles Involved */}
              <Grid2 size={12}>
                {readOnly ? (
                  renderReadOnlyValue(
                    "Muscles Involved",
                    formData?.examination?.musclesInvolved?.join(", "),
                  )
                ) : (
                  <FormControl component="fieldset" fullWidth>
                    <FormLabel component="legend">Muscles Involved</FormLabel>
                    <FormGroup>
                      <Grid2 container>
                        {muscleOptions.map((muscle) => (
                          <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={muscle}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    formData?.examination?.musclesInvolved?.includes(
                                      muscle,
                                    ) || false
                                  }
                                  onChange={() => {
                                    const currentMuscles =
                                      formData?.examination?.musclesInvolved ||
                                      [];
                                    const newMuscles = currentMuscles.includes(
                                      muscle,
                                    )
                                      ? currentMuscles.filter(
                                          (m) => m !== muscle,
                                        )
                                      : [...currentMuscles, muscle];
                                    setFormData({
                                      ...formData,
                                      examination: {
                                        ...formData?.examination,
                                        musclesInvolved: newMuscles,
                                      },
                                    });
                                    handleFormDataChange({
                                      examination: {
                                        ...formData?.examination,
                                        musclesInvolved: newMuscles,
                                      },
                                    });
                                  }}
                                />
                              }
                              label={muscle}
                            />
                          </Grid2>
                        ))}
                      </Grid2>
                    </FormGroup>
                  </FormControl>
                )}
              </Grid2>

              {/* ROM Table - Keep existing code, just update field access */}
              <Grid2 size={12}>
                <Typography fontWeight="bold" gutterBottom>
                  Range of Motion (ROM)
                </Typography>
                <Box sx={{ overflowX: "auto" }}>
                  <Table size="small" sx={{ minWidth: "600px" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Movement
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Normal ROM
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Passive ROM (Left)
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Passive ROM (Right)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {formData?.examination?.rom?.map((movement) => (
                        <TableRow
                          key={movement.name}
                          sx={{
                            "&:hover": {
                              backgroundColor: "transparent !important",
                            },
                            "&.Mui-selected": {
                              backgroundColor: "transparent !important",
                            },
                            "&.Mui-selected:hover": {
                              backgroundColor: "transparent !important",
                            },
                          }}
                        >
                          <TableCell>{movement.displayName}</TableCell>
                          <TableCell align="center">
                            {movement.normal}°
                          </TableCell>
                          <TableCell align="center">
                            {readOnly ? (
                              renderReadOnlyValue(
                                "",
                                formData?.examination?.rom?.find(
                                  (r) => r.name === movement.name,
                                )?.left + "°" || "",
                              )
                            ) : (
                              <TextField
                                type="number"
                                size="small"
                                value={
                                  formData?.examination?.rom?.find(
                                    (r) => r.name === movement.name,
                                  )?.left || ""
                                }
                                onChange={(e) => {
                                  const updatedRom =
                                    formData?.examination?.rom?.map((r) =>
                                      r.name === movement.name
                                        ? {
                                            ...r,
                                            left: e.target.value,
                                          }
                                        : r,
                                    );
                                  setFormData({
                                    ...formData,
                                    examination: {
                                      ...formData.examination,
                                      rom: updatedRom,
                                    },
                                  });
                                  handleFormDataChange({
                                    examination: {
                                      ...formData.examination,
                                      rom: updatedRom,
                                    },
                                  });
                                }}
                                sx={{ width: "200px" }}
                                placeholder="Enter value"
                              />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {readOnly ? (
                              renderReadOnlyValue(
                                "",
                                formData?.examination?.rom?.find(
                                  (r) => r.name === movement.name,
                                )?.right + "°" || "",
                              )
                            ) : (
                              <TextField
                                type="number"
                                size="small"
                                value={
                                  formData?.examination?.rom?.find(
                                    (r) => r.name === movement.name,
                                  )?.right || ""
                                }
                                onChange={(e) => {
                                  const updatedRom =
                                    formData?.examination?.rom?.map((r) =>
                                      r.name === movement.name
                                        ? {
                                            ...r,
                                            right: e.target.value,
                                          }
                                        : r,
                                    );
                                  setFormData({
                                    ...formData,
                                    examination: {
                                      ...formData.examination,
                                      rom: updatedRom,
                                    },
                                  });
                                  handleFormDataChange({
                                    examination: {
                                      ...formData.examination,
                                      rom: updatedRom,
                                    },
                                  });
                                }}
                                sx={{ width: "200px" }}
                                placeholder="Enter value"
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Grid2>

              {/* Grip & Pinch */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Grip & Pinch",
                      formData?.examination?.gripPinch,
                    )
                  : renderDropdownRow(
                      "Grip & Pinch",
                      formData?.examination?.gripPinch,
                      (value) => {
                        setFormData({
                          ...formData,
                          examination: {
                            ...formData?.examination,
                            gripPinch: value,
                          },
                        });
                        handleFormDataChange({
                          examination: {
                            ...formData?.examination,
                            gripPinch: value,
                          },
                        });
                      },
                      ["Strong", "Weak"],
                    )}
              </Grid2>

              {/* Tone */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue("Tone", formData.examination.tone)
                  : renderDropdownRow(
                      "Tone",
                      formData?.examination?.tone,
                      (value) => {
                        setFormData({
                          ...formData,
                          examination: {
                            ...formData?.examination,
                            tone: value,
                          },
                        });
                        handleFormDataChange({
                          examination: {
                            ...formData?.examination,
                            tone: value,
                          },
                        });
                      },
                      ["Normal", "Hypertonic", "Hypotonic"],
                    )}
              </Grid2>

              {/* Coordination */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Coordination",
                      formData?.examination?.coordination,
                    )
                  : renderDropdownRow(
                      "Coordination",
                      formData?.examination?.coordination,
                      (value) => {
                        setFormData({
                          ...formData,
                          examination: {
                            ...formData?.examination,
                            coordination: value,
                          },
                        });
                        handleFormDataChange({
                          examination: {
                            ...formData?.examination,
                            coordination: value,
                          },
                        });
                      },
                      ["Good", "Moderate", "Poor"],
                    )}
              </Grid2>
              <Grid2 size={12}>
                {readOnly ? (
                  renderReadOnlyValue(
                    "Examination Notes",
                    formData?.examination?.notes,
                  )
                ) : (
                  <NotesTextField
                    value={formData?.examination?.notes || ""}
                    onChange={(newValue) => {
                      setFormData({
                        ...formData,
                        examination: {
                          ...formData?.examination,
                          notes: newValue,
                        },
                      });
                      handleFormDataChange({
                        examination: {
                          ...formData?.examination,
                          notes: newValue,
                        },
                      });
                    }}
                    label="Examination Notes"
                    rows={3}
                  />
                )}
              </Grid2>
            </Grid2>
          </AccordionDetails>
        </Accordion>
      </Grid2>

      {/* Special Tests */}
      <Grid2 size={12}>
        <Accordion variant="outlined">
          <AccordionSummary expandIcon={<GridExpandMoreIcon />}>
            <Typography component="span">Special Tests</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "16px" }}>
            <Grid2 container size={12} spacing={3}>
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Thumb Drop Test",
                      formData?.specialTests?.thumbDropTest,
                    )
                  : renderDropdownRow(
                      "Thumb Drop Test",
                      formData?.specialTests?.thumbDropTest,
                      (value) => {
                        setFormData({
                          ...formData,
                          specialTests: {
                            ...formData?.specialTests,
                            thumbDropTest: value,
                          },
                        });
                        handleFormDataChange({
                          specialTests: {
                            ...formData?.specialTests,
                            thumbDropTest: value,
                          },
                        });
                      },
                      ["Positive", "Negative"],
                    )}
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "Painful Arc Test",
                      formData?.specialTests?.painfulArcTest,
                    )
                  : renderDropdownRow(
                      "Painful Arc Test",
                      formData?.specialTests?.painfulArcTest,
                      (value) => {
                        setFormData({
                          ...formData,
                          specialTests: {
                            ...formData?.specialTests,
                            painfulArcTest: value,
                          },
                        });
                        handleFormDataChange({
                          specialTests: {
                            ...formData?.specialTests,
                            painfulArcTest: value,
                          },
                        });
                      },
                      ["Positive", "Negative"],
                    )}
              </Grid2>
              <Grid2 size={12}>
                <Grid2 size={12}>
                  {readOnly ? (
                    renderReadOnlyValue(
                      "Special Tests Notes",
                      formData?.specialTests?.notes,
                    )
                  ) : (
                    <NotesTextField
                      value={formData?.specialTests?.notes || ""}
                      onChange={(newValue) => {
                        setFormData({
                          ...formData,
                          specialTests: {
                            ...formData?.specialTests,
                            notes: newValue,
                          },
                        });
                        handleFormDataChange({
                          specialTests: {
                            ...formData?.specialTests,
                            notes: newValue,
                          },
                        });
                      }}
                      label="Special Tests Notes"
                      rows={3}
                    />
                  )}
                </Grid2>
              </Grid2>
            </Grid2>
          </AccordionDetails>
        </Accordion>
      </Grid2>

      {/* Functional Assessment */}
      <Grid2 size={12}>
        <Accordion variant="outlined">
          <AccordionSummary expandIcon={<GridExpandMoreIcon />}>
            <Typography component="span">Functional Assessment</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "16px" }}>
            <Grid2 container size={12} spacing={1}>
              {/* ADL */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                {readOnly
                  ? renderReadOnlyValue(
                      "ADL",
                      formData?.functionalAssessment?.adl,
                    )
                  : renderDropdownRow(
                      "ADL",
                      formData?.functionalAssessment?.adl,
                      (value) => {
                        setFormData({
                          ...formData,
                          functionalAssessment: {
                            ...formData?.functionalAssessment,
                            adl: value,
                          },
                        });
                        handleFormDataChange({
                          functionalAssessment: {
                            ...formData?.functionalAssessment,
                            adl: value,
                          },
                        });
                      },
                      ["Dependent", "Independent"],
                    )}
              </Grid2>

              {/* Difficulties */}
              <Grid2 size={12}>
                {readOnly ? (
                  renderReadOnlyValue(
                    "Difficulty In",
                    formData?.functionalAssessment?.difficulties?.join(", "),
                  )
                ) : (
                  <FormControl component="fieldset" fullWidth>
                    <FormLabel component="legend">Difficulty In</FormLabel>
                    <FormGroup>
                      <Grid2 container>
                        {difficultyOptions.map((difficulty) => (
                          <Grid2
                            size={{ xs: 12, sm: 6, md: 4 }}
                            key={difficulty}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    formData?.functionalAssessment?.difficulties?.includes(
                                      difficulty,
                                    ) || false
                                  }
                                  onChange={() => {
                                    const currentDifficulties =
                                      formData?.functionalAssessment
                                        ?.difficulties || [];
                                    const newDifficulties =
                                      currentDifficulties.includes(difficulty)
                                        ? currentDifficulties.filter(
                                            (d) => d !== difficulty,
                                          )
                                        : [...currentDifficulties, difficulty];
                                    setFormData({
                                      ...formData,
                                      functionalAssessment: {
                                        ...formData?.functionalAssessment,
                                        difficulties: newDifficulties,
                                      },
                                    });
                                    handleFormDataChange({
                                      functionalAssessment: {
                                        ...formData?.functionalAssessment,
                                        difficulties: newDifficulties,
                                      },
                                    });
                                  }}
                                />
                              }
                              label={difficulty}
                            />
                          </Grid2>
                        ))}
                      </Grid2>
                    </FormGroup>
                  </FormControl>
                )}
              </Grid2>
              <Grid2 size={12}>
                {readOnly ? (
                  renderReadOnlyValue(
                    "Functional Assessment Notes",
                    formData?.functionalAssessment?.notes || "",
                  )
                ) : (
                  <NotesTextField
                    value={formData?.functionalAssessment?.notes || ""}
                    onChange={(newValue) => {
                      setFormData({
                        ...formData,
                        functionalAssessment: {
                          ...formData?.functionalAssessment,
                          notes: newValue,
                        },
                      });
                      handleFormDataChange({
                        functionalAssessment: {
                          ...formData?.functionalAssessment,
                          notes: newValue,
                        },
                      });
                    }}
                    label="Functional Assessment Notes"
                    rows={3}
                  />
                )}
              </Grid2>
            </Grid2>
          </AccordionDetails>
        </Accordion>
      </Grid2>

      {/* Physiotherapy Management Plan */}
      <Grid2 size={12}>
        <Accordion variant="outlined">
          <AccordionSummary expandIcon={<GridExpandMoreIcon />}>
            <Typography component="span">
              Physiotherapy Management Plan
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "16px" }}>
            <Grid2 container size={12} spacing={3}>
              {/* Modalities */}
              <Grid2 size={12}>
                {readOnly ? (
                  renderReadOnlyValue(
                    "Modalities",
                    formData?.managementPlan?.modalities?.join(", "),
                  )
                ) : (
                  <FormControl component="fieldset" fullWidth>
                    <FormLabel component="legend">Modalities</FormLabel>
                    <FormGroup>
                      <Grid2 container>
                        {modalityOptions.map((modality) => (
                          <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={modality}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    formData?.managementPlan?.modalities?.includes(
                                      modality,
                                    ) || false
                                  }
                                  onChange={() => {
                                    const currentModalities =
                                      formData?.managementPlan?.modalities ||
                                      [];
                                    const newModalities =
                                      currentModalities.includes(modality)
                                        ? currentModalities.filter(
                                            (m) => m !== modality,
                                          )
                                        : [...currentModalities, modality];
                                    setFormData({
                                      ...formData,
                                      managementPlan: {
                                        ...formData?.managementPlan,
                                        modalities: newModalities,
                                      },
                                    });
                                    handleFormDataChange({
                                      managementPlan: {
                                        ...formData?.managementPlan,
                                        modalities: newModalities,
                                      },
                                    });
                                  }}
                                />
                              }
                              label={modality}
                            />
                          </Grid2>
                        ))}
                      </Grid2>
                    </FormGroup>
                  </FormControl>
                )}
              </Grid2>

              {/* Exercise Plan */}
              <Grid2 size={12}>
                {readOnly ? (
                  renderReadOnlyValue(
                    "Exercise Plan",
                    formData?.managementPlan?.exercisePlan?.join(", "),
                  )
                ) : (
                  <FormControl component="fieldset" fullWidth>
                    <FormLabel component="legend">Exercise Plan</FormLabel>
                    <FormGroup>
                      <Grid2 container>
                        {exerciseOptions.map((exercise) => (
                          <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={exercise}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    formData?.managementPlan?.exercisePlan?.includes(
                                      exercise,
                                    ) || false
                                  }
                                  onChange={() => {
                                    const currentExercises =
                                      formData?.managementPlan?.exercisePlan ||
                                      [];
                                    const newExercises =
                                      currentExercises.includes(exercise)
                                        ? currentExercises.filter(
                                            (e) => e !== exercise,
                                          )
                                        : [...currentExercises, exercise];
                                    setFormData({
                                      ...formData,
                                      managementPlan: {
                                        ...formData?.managementPlan,
                                        exercisePlan: newExercises,
                                      },
                                    });
                                    handleFormDataChange({
                                      managementPlan: {
                                        ...formData?.managementPlan,
                                        exercisePlan: newExercises,
                                      },
                                    });
                                  }}
                                />
                              }
                              label={exercise}
                            />
                          </Grid2>
                        ))}
                      </Grid2>
                    </FormGroup>
                  </FormControl>
                )}
              </Grid2>

              {/* Prognosis */}
              <Grid2 size={12}>
                {/* <Typography fontWeight="bold" gutterBottom>
                          Prognosis (in Patient's Words)
                        </Typography> */}
                {readOnly ? (
                  renderReadOnlyValue(
                    "Prognosis",
                    formData?.managementPlan?.prognosis,
                  )
                ) : (
                  <NotesTextField
                    value={formData?.managementPlan?.prognosis || ""}
                    onChange={(newValue) => {
                      setFormData({
                        ...formData,
                        managementPlan: {
                          ...formData?.managementPlan,
                          prognosis: newValue,
                        },
                      });
                      handleFormDataChange({
                        managementPlan: {
                          ...formData?.managementPlan,
                          prognosis: newValue,
                        },
                      });
                    }}
                    label="Enter prognosis details"
                    rows={3}
                  />
                )}
              </Grid2>
            </Grid2>
          </AccordionDetails>
        </Accordion>
      </Grid2>
    </Grid2>
  );
}

export default FrozenShoulderPrescriptionDisplay;
